





































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import PropertyFormRecordType from '@/modules/Property/components/forms/PropertyFormRecordType.vue'
import PropertyFormInfo from '@/modules/Property/components/forms/PropertyFormInfo.vue'
import PropertyFormAdditionalInfo from '@/modules/Property/components/forms/PropertyFormAdditionalInfo.vue'
import PropertyFormAdditional from '@/modules/Property/components/forms/PropertyFormAdditional.vue'
import { Property } from '@/modules/Property/interfaces/property'
import RecordTypesHandler from '@/mixins/record-types'
import { newProperty, editProperty } from '@/modules/Property/gql/property.gql'
import { Case } from '@/modules/Case/interfaces/case'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { IPropertyRecordTypeInput, IPropertyInfoInput, IPropertyAdditionalInput, IPropertyAdditionalInfoInput } from '@/modules/Property/interfaces/property-form'
import { states } from '@/utils/us_states'

@Component({
  components: {
    PropertyFormRecordType,
    PropertyFormInfo,
    AppDialog,
    PropertyFormAdditional,
    PropertyFormAdditionalInfo,
    AppSteps
  }
})
export default class PropertyForm extends mixins(RecordTypesHandler) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Property }) readonly property!: Property
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  showDialog = false
  loading = false

  recordTypeIndex = 0
  stepIndex = 0
  steps = [
    ['Record Type', 680, 561],
    ['Information', 770, 361],
    ['Additional Info', 770, 401],
    ['Property Detail', 770, 711]
  ]

  recordTypeInput: IPropertyRecordTypeInput = {
    recordType: {}
  }

  infoInput: IPropertyInfoInput = {
    address: '',
    city: '',
    stateIdx: -1,
    zipCode: ''
  }

  additionalInput: IPropertyAdditionalInput = {
    loanNumber: '',
    currentCoverage: '',
    notes: ''
  }

  additionalInfoInput: IPropertyAdditionalInfoInput = {}

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return this.recordTypeInput.recordType.name ? ' (' + this.recordTypeInput.recordType.name + ')' : ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.property
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.property ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex === 2
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    this.showDialog = val
    if (val) {
      this.resetStep()
      this.initInput()
    }
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.property) {
      const {
        recordType,
        address, city, state, zipCode,
        loanNumber, currentCoverage, notes,
        additionalInfoStr
      } = this.property
      this.recordTypeInput = {
        recordType: {
          id: +recordType.id,
          name: recordType.name
        }
      }
      this.infoInput = {
        address,
        city,
        stateIdx: states.findIndex(item => item === state),
        zipCode
      }
      this.additionalInput = {
        loanNumber,
        currentCoverage,
        notes
      }
      const additionalInfo = JSON.parse(additionalInfoStr)
      this.additionalInfoInput = { ...additionalInfo }
    } else {
      this.clearForm()
    }
  }

  handleStepClick (index: number) {
    if (!this.property) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.property) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    this.stepIndex -= 1
  }

  async handleCreate () {
    const {
      recordTypeInput: { recordType: { id: recordTypeId } },
      infoInput: {
        address,
        city,
        stateIdx,
        zipCode
      },
      additionalInput: {
        loanNumber,
        currentCoverage,
        notes
      }
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: newProperty,
        variables: {
          propertyInput: {
            address,
            city,
            state: states[stateIdx] || '',
            zipCode,
            currentCoverage,
            loanNumber,
            notes,
            additionalInfo: this.parseAdditionalInfo(),
            recordTypeId,
            quoteId: this.quote ? Number(this.quote.id) : null,
            policyId: this.policy ? Number(this.policy.id) : null,
            caseId: this.caseInfo ? Number(this.caseInfo.id) : null
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new property successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      recordTypeInput: { recordType: { id: recordTypeId } },
      infoInput: {
        address,
        city,
        stateIdx,
        zipCode
      },
      additionalInput: {
        loanNumber,
        currentCoverage,
        notes
      }
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: editProperty,
        variables: {
          propertyId: +this.property.id,
          propertyInput: {
            address,
            city,
            state: states[stateIdx] || '',
            zipCode,
            currentCoverage,
            loanNumber,
            notes,
            additionalInfo: this.parseAdditionalInfo(),
            recordTypeId,
            quoteId: this.quote ? Number(this.quote.id) : null,
            policyId: this.policy ? Number(this.policy.id) : null,
            caseId: this.caseInfo ? Number(this.caseInfo.id) : null
          }
        }
      })
      this.clearForm()
      this.onSuccess('Update property successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  parseAdditionalInfo () {
    return JSON.stringify(this.additionalInfoInput, (key, value) => {
      return value === 0 ? '0' : (value || '')
    })
  }

  clearForm () {
    this.loading = false
    this.recordTypeInput = {
      recordType: {}
    }

    this.infoInput = {
      address: '',
      city: '',
      stateIdx: -1,
      zipCode: ''
    }

    this.additionalInput = {
      loanNumber: '',
      currentCoverage: '',
      notes: ''
    }

    this.additionalInfoInput = {}
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (msg = '') {
    this.$emit('input', false)
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
